import { useState } from "react";
import { unlockTeacherFinalExam } from "../../../actions/teacherCoursesAction";
import { Row, Col, Card, Form, Label, Input, Collapse } from "reactstrap";
import { GetAvailableModuleAnswers } from "../../../actions/teacherQueries";
import { PacmanLoader } from "react-spinners";
import CourseItem from "../../../components/Course/CourseItem";
import { getWinOptions, composeUrl } from "../../../Utilities/moduleHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardHeader from "reactstrap/lib/CardHeader";
import CardBody from "reactstrap/lib/CardBody";
import PropTypes from "prop-types";

function TeacherCoursesView(props) {
  TeacherCoursesView.propTypes = {
    coursesData: PropTypes.object.isRequired,
  };

  const [classesToShow] = useState(props.coursesData);
  const [filterSearch, setFilterSearch] = useState("");
  const [toggleModules, setToggleModules] = useState([]);
  const [collapseLicenses, setCollapseLicenses] = useState([]);
  const [documentIsOpen, setDocumentsIsOpen] = useState(false);
  const [teacherMaterialsIsOpen, setTeacherMaterialsIsOpen] = useState(false);
  const [openedTeacherMaterials, setOpenedTeacherMaterials] = useState([]);
  const [openedDocuments, setOpenedDocuments] = useState([]);
  const availableModuleAnswers = GetAvailableModuleAnswers();
  const goToModuleResults = (courseId, moduleId) => {
    if (courseId !== null) {
      props.history.push({
        pathname: "/teacher/courseview/moduleresults",
        state: { course: courseId, module: moduleId },
      });
    }
  };

  const filterSearchfunc = (event) => {
    setFilterSearch(event.target.value);
  };

  const stopEnter = (event) => {
    if (event.which === 13 /* Enter */) {
      event.preventDefault();
    }
  };

  const openModule = (courseId, moduleId, moduleUrl, moduleType) => {
    const studentResultId = -1;
    const userId = -1;

    if (moduleUrl == null) {
      this.setError();
      return;
    }

    props.dispatch(unlockTeacherFinalExam(courseId, moduleId)).then(() => {
      var url = composeUrl(
        userId,
        courseId,
        moduleId,
        moduleType,
        studentResultId,
        moduleUrl,
        null
      );

      var winOptions = getWinOptions();
      window.open(url, "", winOptions);
    });
  };

  const collapseLicensesfunc = (license) => {
    let collapsed = collapseLicenses;

    if (collapsed.indexOf(license) === -1) collapsed.push(license);
    else collapsed.splice(collapsed.indexOf(license), 1);
    setCollapseLicenses(collapsed);
  };

  if (classesToShow.isLoading) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  let filteredList = classesToShow.data;

  if (filterSearch.length > 0) {
    filteredList = classesToShow.data.filter(
      (course) =>
        course.courseName.toLowerCase().indexOf(filterSearch.toLowerCase()) !==
        -1
    );
  }

  const toggleModule = (courseId) => {
    if (!toggleModules.includes(courseId)) {
      if (openedDocuments.includes(courseId)) {
        setOpenedDocuments([
          ...openedDocuments.filter(function (id) {
            return id !== courseId;
          }),
        ]);
      }
      if (openedTeacherMaterials.includes(courseId)) {
        setOpenedTeacherMaterials([
          ...openedTeacherMaterials.filter(function (id) {
            return id !== courseId;
          }),
        ]);
      }
      setToggleModules([...toggleModules, courseId]);
    } else {
      setToggleModules([
        ...toggleModules.filter(function (id) {
          return id !== courseId;
        }),
      ]);
    }
  };

  const toggleDocuments = (courseId) => {
    let od = openedDocuments;
    if (!od.includes(courseId)) {
      if (toggleModules.includes(courseId)) {
        setToggleModules([
          ...toggleModules.filter(function (id) {
            return id !== courseId;
          }),
        ]);
      }
      if (openedTeacherMaterials.includes(courseId)) {
        setOpenedTeacherMaterials([
          ...openedTeacherMaterials.filter(function (id) {
            return id !== courseId;
          }),
        ]);
      }
      od.push(courseId);
    } else {
      od = od.filter((el) => el !== courseId);
    }
    setOpenedDocuments(od);
    setDocumentsIsOpen(!documentIsOpen);
  };

  const toggleTeacherMaterials = (courseId) => {
    let om = openedTeacherMaterials;
    if (!om.includes(courseId)) {
      if (toggleModules.includes(courseId)) {
        setToggleModules([
          ...toggleModules.filter(function (id) {
            return id !== courseId;
          }),
        ]);
      }
      if (openedDocuments.includes(courseId)) {
        setOpenedDocuments([
          ...openedDocuments.filter(function (id) {
            return id !== courseId;
          }),
        ]);
      }
      om.push(courseId);
    } else {
      om = om.filter((el) => el !== courseId);
    }
    setOpenedTeacherMaterials(om);
    setTeacherMaterialsIsOpen(!teacherMaterialsIsOpen);
  };

  let licenses = [];
  classesToShow.data.forEach((x) => {
    if (licenses.indexOf(x.programLicenseName) === -1)
      licenses.push(x.programLicenseName);
  });

  let mappedLicenses = [];

  mappedLicenses = licenses.map((license, i) => (
    <Col lg="12" key={i + props.objId}>
      <Card>
        <CardHeader
          style={{ cursor: "pointer" }}
          title="Fäll ihop/Expandera"
          onClick={() => collapseLicensesfunc(license)}
        >
          {license}
        </CardHeader>
        <Collapse isOpen={collapseLicenses.indexOf(license) === -1}>
          <CardBody>
            <Row className="p-2">
              {filteredList
                .filter((x) => x.programLicenseName === license)
                .sort((a, b) => {
                  return a.courseName > b.courseName ? 1 : 0;
                })
                .map((course) => (
                  <CourseItem
                    course={course}
                    key={course.id + props.objId}
                    teacherInfo={props.teacherInfo}
                    level={props.level}
                    displayDocuments={props.displayDocuments}
                    navigateToModuleResult={goToModuleResults}
                    toggleModules={toggleModule}
                    modulesIsOpen={toggleModules.indexOf(course.id) > -1}
                    openModule={openModule}
                    disableViewResults={true}
                    navigateToCourse={goToModuleResults}
                    documentIsOpen={openedDocuments.indexOf(course.id) > -1}
                    toggleDocumentOpen={toggleDocuments}
                    openedDocuments={openedDocuments}
                    teacherMaterialsIsOpen={
                      openedTeacherMaterials.indexOf(course.id) > -1
                    }
                    setTeacherMaterialsIsOpen={setTeacherMaterialsIsOpen}
                    toggleTeacherMaterials={toggleTeacherMaterials}
                    openedTeacherMaterials={openedTeacherMaterials}
                    availableModuleAnswers={availableModuleAnswers}
                  />
                ))}
            </Row>
          </CardBody>
        </Collapse>
      </Card>
    </Col>
  ));

  return (
    <div className="animated fadeIn">
      <Card body className="rounded border-0 shadow-sm ms-2 me-2">
        <Form
          onKeyPress={(event) => stopEnter(event)}
          className="d-flex align-items-center "
        >
          <div className="w-100 position-relative">
            <FontAwesomeIcon
              icon="search"
              className="position-absolute top-50 start-0 translate-middle-y ms-3"
            />
            <Input
              id="searchInput"
              className="rounded-4 ps-5"
              onChange={(event) => filterSearchfunc(event)}
              placeholder="Kursens namn"
            >
              <Label for="searchInput" className="form-label">
                Sök
              </Label>
            </Input>
          </div>
        </Form>
      </Card>
      <Row>{mappedLicenses}</Row>
    </div>
  );
}

export default TeacherCoursesView;
